import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';

import { IApplicationContext, IApplicationContextCustom } from '../../../shared/types/applicationContext';
import { getHeaderMicrofrontendApi } from '../../utils/getHeaderMicrofrontendApi';

export const createContext = (): IApplicationContext => {
  const config = getConfig();
  const custom = config.getStrict<IApplicationContextCustom>('applicationContext.custom');

  return {
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    custom: {
      ...custom,
      headerFrontendApi: getHeaderMicrofrontendApi(),
    },
  };
};
